// /bmp/currencies

import Decimal from "decimal.js";
import { responseHero } from "../utils/axiosInterceptor";

export type BybitPricesResponse = {
    btc: Decimal | null;
    eth: Decimal | null;
}

export const getBybitPricesData = (): Promise<BybitPricesResponse> => {
    return new Promise<BybitPricesResponse>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/currencies`).then((response) => {
            resolve(response.data as BybitPricesResponse);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};